import Upload from './Upload'
import List from './List'
import SpareList from './SpareList'
import Single from './Single'
import Video from './Video'
import File from './File'
import Btn from './Btn'
import Dragger from './Dragger'
import TaskProgress from './TaskProgress'

export * from './helper'

Upload.List = List
Upload.SpareList = SpareList
Upload.Single = Single
Upload.Video = Video
Upload.File = File
Upload.Btn = Btn
Upload.Dragger = Dragger
Upload.TaskProgress = TaskProgress

export default Upload
